module.exports = "<div class=\"error-container\">\n    <div *ngFor=\"let error of errors\">{{error}}</div>\n</div>"